import {
    extractDeepLinkPath,
    isParentPath,
} from "@common/utils/navigationUtils"

/**
 * Does the link waiting for a login lead to the parent space?
 *
 * `true` / `false` when the link has a readable path, `null` otherwise (no
 * link, or one we can't read — the account picker then leaves it alone). The
 * picker drops a link that the chosen side can't open: a parent link when an
 * account opens, a student link when « Espace parent » opens.
 *
 * Not a pure function: `isParentPath` derives the parent paths from the
 * navigation table, which lives in common/. It sits in data/ next to
 * `resolveAutoBypassTarget` (`data/utility/familyUtils`), which reads the same
 * classifier, so the ports layer reaches it without importing common/.
 */
export const pendingDeepLinkIsParentPath = (pendingDeepLink) => {
    if (!pendingDeepLink) return null
    const path = extractDeepLinkPath(pendingDeepLink)
    if (!path) return null
    return isParentPath(path)
}
